import { classNames } from "primereact/utils";

import styles from "./rotulo-obra.module.scss";
import type { RotuloObraProps, RotuloObraViewModel } from "./types-rotulo-obra";

/** Rótulo de uma linha só: o texto visível sobre o nome invisível (pseudo-elemento, fora do texto da página) que fixa a largura natural; sobrando, reticências. */
export function RotuloObraView({
  className,
  testId,
  nome,
  texto,
  registrarRaiz,
  medidaRef,
}: RotuloObraProps & RotuloObraViewModel) {
  return (
    <span ref={registrarRaiz} className={classNames(styles.root, className)} data-testid={testId}>
      <span className={styles.texto}>{texto}</span>
      <span ref={medidaRef} className={styles.medida} data-nome={nome} aria-hidden />
    </span>
  );
}
